import { render, staticRenderFns } from "./createDiscount.vue?vue&type=template&id=3367f454"
import script from "./createDiscount.vue?vue&type=script&lang=js"
export * from "./createDiscount.vue?vue&type=script&lang=js"
import style0 from "./createDiscount.vue?vue&type=style&index=0&id=3367f454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports